import { useContext } from "react"
import type { DarkModeContextValue } from "./DarkModeContext"
import { DarkModeContext } from "./DarkModeContext"

export function useDarkMode(): DarkModeContextValue {
  return useContext(DarkModeContext)
}

